exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagerror {\n  color: black;\n  margin: 8em 2em 0em 2em;\n  padding-top: -2em;\n  padding-bottom: 2em;\n  position: relative;\n  word-wrap: break-word;\n  background-color: rgba(255, 255, 255, .99);\n  background-clip: border-box;\n  border: 1px solid rgba(0, 0, 0, .125);\n  border-radius: 0.25rem; }\n\n#testo {\n  padding-top: 0px;\n  z-index: 100;\n  margin: 8em 2em 0em 2em; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/@epegzz/sass-vars-loader/dist/sassVarsLoader.js??ref--2-4!./src/app/theme/components/app-error/error.component.scss
// module id = fWHn
// module chunks = 4